import React from 'react';
import { useNavigate } from 'react-router-dom';

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="policy-page-container">
      {/* Header */}
      <header className="policy-page-header">
        <div className="policy-header-content">
          <h1>Privacy Policy</h1>
          <button className="btn-home" onClick={() => navigate('/')}>
            🏠 HOME
          </button>
        </div>
      </header>

      {/* Content */}
      <div className="content-wrapper">
      <div className="content-inner">
        <div className="card-container">
          <h2 className="section-title mb-2">Privacy Policy</h2>
          <p className="section-subtitle mb-4">Your privacy matters to us</p>

          <div className="policy-content">
            <section className="policy-section">
              <h3>1. Introduction</h3>
              <p>
                At Stick Audio, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our text-to-speech service.
              </p>
            </section>

            <section className="policy-section">
              <h3>2. Information We Collect</h3>
              <p>
                We collect information you provide directly to us, such as when you:
              </p>
              <ul>
                <li>Create an account or sign in with Google</li>
                <li>Generate text-to-speech audio</li>
                <li>Upload custom voice samples</li>
                <li>Create and manage API keys</li>
                <li>Contact us for support</li>
              </ul>
            </section>

            <section className="policy-section">
              <h3>3. How We Use Your Information</h3>
              <p>
                We use the information we collect to:
              </p>
              <ul>
                <li>Provide and improve our text-to-speech service</li>
                <li>Process text-to-speech requests and generate audio</li>
                <li>Manage your account and API keys</li>
                <li>Track generation history and credit usage</li>
                <li>Send you service-related notifications</li>
                <li>Respond to your inquiries and support requests</li>
                <li>Detect and prevent fraud or security issues</li>
              </ul>
            </section>

            <section className="policy-section">
              <h3>4. Data Storage and Security</h3>
              <p>
                Your data is stored securely using industry-standard encryption and security measures. We use Supabase for database storage and audio file storage. Generated audio files are stored temporarily and can be deleted at your request.
              </p>
            </section>

            <section className="policy-section">
              <h3>5. API Keys and Authentication</h3>
              <p>
                API keys are securely hashed before storage in our database. We never store your actual API key on our servers - only the hashed version. Treat your API keys like passwords and never share them publicly.
              </p>
            </section>

            <section className="policy-section">
              <h3>6. Google OAuth Authentication</h3>
              <p>
                We use Google OAuth 2.0 for secure authentication. We only access your basic profile information (email, name, profile picture) provided by Google. We do not request or access your Google account credentials.
              </p>
            </section>

            <section className="policy-section">
              <h3>7. Third-Party Services</h3>
              <p>
                We use the following third-party services:
              </p>
              <ul>
                <li><strong>Supabase:</strong> For database and file storage</li>
                <li><strong>Google OAuth:</strong> For authentication</li>
                <li><strong>Stripe:</strong> For payment processing (credit topups)</li>
              </ul>
              <p>
                These services have their own privacy policies. We recommend reviewing them to understand how they handle your data.
              </p>
            </section>

            <section className="policy-section">
              <h3>8. Credit System</h3>
              <p>
                Your credit balance and usage history are stored securely. Credits are tracked per user and never expire. Payment information is processed through Stripe and we do not store your full credit card details.
              </p>
            </section>

            <section className="policy-section">
              <h3>9. Data Retention</h3>
              <p>
                We retain your account information as long as your account is active. You can request deletion of your account and associated data at any time. Generated audio files are retained based on your preferences and can be deleted individually or in bulk.
              </p>
            </section>

            <section className="policy-section">
              <h3>10. Your Rights</h3>
              <p>
                You have the right to:
              </p>
              <ul>
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Delete your account and data</li>
                <li>Export your data</li>
                <li>Opt-out of non-essential communications</li>
              </ul>
            </section>

            <section className="policy-section">
              <h3>11. Policy Changes</h3>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by updating the "Last Updated" date of this policy. Your continued use of our service after any changes constitutes your acceptance of the updated Privacy Policy.
              </p>
            </section>

            <section className="policy-section">
              <h3>12. Contact Us</h3>
              <p>
                If you have questions about this Privacy Policy or our privacy practices, please contact us at{' '}
                <a href="mailto:support@stick.audio" className="contact-link">support@stick.audio</a>
              </p>
            </section>

            <div className="policy-footer">
              <p><strong>Last Updated:</strong> January 2025</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Privacy;
